/* eslint-disable @typescript-eslint/no-unsafe-return -- old code, allow */

import { useLocalStorage } from 'usehooks-ts'
import config from '@/config'

const tokenStorageKey = `${config.localStorageKeys.userCredentials}_${
  config.prod ? 'prd' : 'stg'
}`

export interface LocalStorageAccessToken {
  accessToken: string
  refreshToken: string
  scope: string | null | undefined // not sure why but sometimes this is null.
}

export const getToken = (): LocalStorageAccessToken | null => {
  const item = localStorage.getItem(tokenStorageKey)

  if (!item) {
    return null
  }

  return JSON.parse(item)
}

export const useAccessToken = () => {
  const [token] = useLocalStorage<{ accessToken: string }>(tokenStorageKey, {
    accessToken: '',
  })
  return token
}

export const setToken = (token: LocalStorageAccessToken) => {
  localStorage.setItem(tokenStorageKey, JSON.stringify(token))
}

export interface ApiUserRefreshTokenResponse {
  access_token?: string
  expires_in?: number
  refresh_token?: string
  scope?: null // FIXME: what type should this be
  token_type?: 'Bearer'
  error?: string
  error_description?: string
}
